import { ChangeSet, ChangeSetBM } from '../types/ChangeSetTypes';
import { getChangeSetCategoryName } from '../enums/ChangeSetCategoryEnum';
import { getChangeSetStatusName } from '../enums/ChangeSetStatusEnum';
import { getChangeSetTypeName } from '../enums/ChangeSetTypeEnum';

/**
 * Maps a ChangeSetBM (Business Model from API) to a ChangeSet (View Model for UI)
 */
export const mapChangeSetBM = (bm: ChangeSetBM): ChangeSet => {
    return {
        id: bm.id,
        userName: bm.userName || 'Unknown User',
        date: new Date(bm.dateTimeUtc),
        category: bm.targetOfChange,
        categoryName: getChangeSetCategoryName(bm.targetOfChange),
        reviewerName: bm.reviewerName,
        reviewDate: bm.reviewDateTimeUtc ? new Date(bm.reviewDateTimeUtc) : null,
        status: bm.reviewStatus,
        statusName: getChangeSetStatusName(bm.reviewStatus),
        displayInformation: bm.displayInformation || '',
        type: bm.type,
        typeName: getChangeSetTypeName(bm.type),
        newValues: bm.newValues,
        oldValues: bm.oldValues,
    };
};

/**
 * Maps an array of ChangeSetBMs to ChangeSets
 */
export const mapChangeSetBMs = (bms: ChangeSetBM[]): ChangeSet[] => {
    if (!bms || !Array.isArray(bms)) {
        return [];
    }
    return bms.map(mapChangeSetBM);
};

/**
 * Sorts change sets by date (newest first)
 */
export const sortChangeSetsByDate = (changeSets: ChangeSet[]): ChangeSet[] => {
    return [...changeSets].sort((a, b) => b.date.getTime() - a.date.getTime());
};

/**
 * Filters change sets by status
 */
export const filterChangeSetsByStatus = (changeSets: ChangeSet[], statusFilter: number[]): ChangeSet[] => {
    if (!statusFilter || statusFilter.length === 0) {
        return changeSets;
    }
    return changeSets.filter((cs) => statusFilter.includes(cs.status));
};

/**
 * Filters change sets by category
 */
export const filterChangeSetsByCategory = (changeSets: ChangeSet[], categoryFilter: number[]): ChangeSet[] => {
    if (!categoryFilter || categoryFilter.length === 0) {
        return changeSets;
    }
    return changeSets.filter((cs) => categoryFilter.includes(cs.category));
};

/**
 * Filters change sets by type
 */
export const filterChangeSetsByType = (changeSets: ChangeSet[], typeFilter: number[]): ChangeSet[] => {
    if (!typeFilter || typeFilter.length === 0) {
        return changeSets;
    }
    return changeSets.filter((cs) => typeFilter.includes(cs.type));
};
